module.exports = __webpack_public_path__ + "media/images/landing/client_Adobe-697269b54953274bf3b4366763f8a1a3.png";